import React from 'react';
import { Alert, Box, Link, TextInput, TrashIcon } from '@razorpay/blade/components';
import { SelectDispensary } from './SelectDispensary';
import { BorderedBox } from 'components/EmployeeOnboarding/components/styles';
import { useOfficeLocationForm } from '../hooks/useOfficeLocationForm';
import { SelectState } from './SelectState';
import { SelectDistrict } from './SelectDistrict';

export const OfficeLocationForm = React.memo(({ formId, error }: { formId: string | number, error?: string }) => {
  const { formData, updateField, register, deleteForm } = useOfficeLocationForm(formId);

  const handleDeleteOfficeLocation = () => {
    deleteForm();
  };

  return (
    <BorderedBox>
      <TextInput
        label="Office Name"
        necessityIndicator="required"
        placeholder="Enter office name"
        size="medium"
        {...register({ name: 'officeName' })}
      />

      <TextInput
        label="Office Address"
        necessityIndicator="required"
        placeholder="Enter office address"
        size="medium"
        {...register({ name: 'officeAddress' })}
      />

      <Box display="flex" flexDirection="row" gap="spacing.5" flex="1">
        <SelectState
          register={register}
          formData={formData}
          onChangeSuccess={() => {
            updateField('district', []);
            updateField('esicDispensary', []);
          }}
        />
        <SelectDistrict
          register={register}
          formData={formData}
          onChangeSuccess={() => {
            updateField('esicDispensary', []);
          }}
        />
      </Box>

      <TextInput
        label="Pincode"
        necessityIndicator="required"
        placeholder="Enter Pincode"
        size="medium"
        {...register({ name: 'pincode' })}
      />

      <SelectDispensary register={register} formData={formData} />

      <TextInput
        label="ESIC Sub-Code"
        necessityIndicator="none"
        helpText="Location-specific sub-code assigned by the government"
        placeholder="Enter ESIC Sub-Code"
        size="medium"
        {...register({ name: 'esicSubCode' })}
      />

      {error ? <Alert isDismissible={false} color="negative" description={error} /> : null}

      <Box display="flex" justifyContent="center">
        <Link
          onClick={handleDeleteOfficeLocation}
          color="negative"
          variant="button"
          icon={TrashIcon}>
          Delete Office Location
        </Link>
      </Box>
    </BorderedBox>
  );
});
